import { segmentMst } from '@libs/domain';
import {
  CheckboxInFieldBody,
  FieldHead,
  FormField,
  InputNumberInFieldBody,
  InputStringInFieldBody,
} from '@ps-smart-cp/ppfw-client';
import { useOperationControl } from '../../../context';
import { segmentMstSettingFieldConfig } from '../item-config';
import type { SegmentMstSetting } from '../models';

interface SegmentSettingRowProps {
  segmentMstKey: number;
  setting: SegmentMstSetting;
  setSetting: (setting: SegmentMstSetting) => void;
  errorFields?: string[];
  previousDisabled?: boolean;
}

function SegmentSettingRow(props: SegmentSettingRowProps) {
  const { segmentMstKey, setting, errorFields, setSetting, previousDisabled } = props;
  const row = segmentMstKey + 1;
  const { isStarted } = useOperationControl();

  return (
    <div style={{ display: 'contents' }}>
      <div style={{ gridArea: `${row}/1`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <FieldHead
            itemName={
              segmentMst.names[`segment0${segmentMstKey.toString()}` as keyof typeof segmentMst.names]
            }
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/2`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <CheckboxInFieldBody
            id={`segment-is-used-${segmentMstKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="isUsed"
            transparentBorder
            labelName=""
            errorFields={errorFields}
            disabled={isStarted ? true : previousDisabled}
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/3`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <InputStringInFieldBody
            id={`segment-display-name-${segmentMstKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="displayName"
            itemAttribute={segmentMstSettingFieldConfig.displayName.attribute}
            errorFields={errorFields}
            disabled={isStarted ? true : !setting.isUsed}
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/4`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <InputNumberInFieldBody
            id={`segment-code-digits-${segmentMstKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="codeDigits"
            itemAttribute={segmentMstSettingFieldConfig.codeDigits.attribute}
            errorFields={errorFields}
            disabled={isStarted ? true : !setting.isUsed}
          />
        </FormField>
      </div>
    </div>
  );
}

export { SegmentSettingRow };
export type { SegmentSettingRowProps };
